<template>
  <CompanyInfoComponent />
</template>

<script>
// @ is an alias to /src
import CompanyInfoComponent from "@/components/Account/Pages/CompanyInfo/CompanyInfo.vue";

export default {
  name: "CompanyInfo",
  components: {
    CompanyInfoComponent
  }
};
</script>
